module.exports = {
   port: process.env.PORT || 10000,
   apiUrl: '/api',
   cspViolationReportUrl: 'https://o238812.ingest.sentry.io/api/1409459/security/?sentry_key=0635f9f7945a45dd854ee5406923d508',
   froalaKey: 'FSC2H-9D1A17B8C2pZGCTRSAPJWTLPLZHTQQe1JGZxC4B3A3B2B5A1F1E4I1C3==',
   dynamicOrganizationDomains: process.env.NODE_ENV === 'production'
      ? ['gather.site', 'staging.gather.site']
      : ['localhost'],
   googleKey: 'AIzaSyDJOUOcvN2h-0aDvA5x13u7gwjnF6k4Hzo',
   sentryDsn: 'https://0635f9f7945a45dd854ee5406923d508@o238812.ingest.sentry.io/1409459',
   stripeLibraryUrl: 'https://js.stripe.com/v3/',
   stripePublishableKey: process.env.NODE_ENV === 'production'
      ? 'pk_live_U6d1Kjzer2WX8nuk8MKVx2n5'
      : 'pk_test_Qlbslg3aF2IONM3hkJwRXBI8'
}
